export default __webpack_public_path__ + "static/media/radio-checked.7c301e7c.svg";